import { zeroPad } from "./zeroPad";

export function formatTime(date: Date | string) {
  const dateObj = date instanceof Date ? date : new Date(date);

  return `${zeroPad(dateObj.getHours())}:${zeroPad(dateObj.getMinutes())}`;
}
